import { useEffect, useState } from "react";

export const useIVA = (
  hasProductoSeleccionado?: boolean,
  onAplicarIVA?: (precioFinalConIVA: number) => void
) => {
  const [showCalcIVA, setShowCalcIVA] = useState(false);
  const [precioConIVA, setPrecioConIVA] = useState<string>("");

  useEffect(() => {
    if (!hasProductoSeleccionado) {
      setShowCalcIVA(false);
      setPrecioConIVA("");
    }
  }, [hasProductoSeleccionado]);

  const aplicarIVA = () => {
    if (!onAplicarIVA) return;
    const n = Number(precioConIVA);
    if (!Number.isFinite(n) || n <= 0) return;
    onAplicarIVA(n);
  };

  return {
    showCalcIVA,
    setShowCalcIVA,
    precioConIVA,
    setPrecioConIVA,
    aplicarIVA,
  };
};
